import { formatInTimeZone } from "date-fns-tz";
import { useMemo } from "react";
import { useOrganizationContacts } from "src/hooks/useOrganization";
import { useFormTemplateContext } from "src/scenes/orgAdmin/formTemplates/formTemplateContext";

// Dummy data for automatic message preview
const PARTIALS = {
  parent: { name: "Elsa Ébert" },
  student: { name: "Johnny Ébert" },
  enrollmentPeriod: { name: "23/24 School Year" },
  form: {
    name: "23/24 Application",
    closeDate: new Date("2023-01-20T08:59:00-0000"),
    offerDate: new Date("2023-02-20T08:59:00-0000"),
  },
  grade: "3rd grade",
  schools: [
    { name: "Tillmãn Elementery", rank: 1, first: true },
    { name: "Glendale Elementary", rank: 2 },
    { name: "Lindbergh Elementary", rank: 3, last: true },
  ],
  offer: {
    schoolName: "Tillman Elementary",
  },
  waitlist: {
    schoolName: "Tillman Elementary",
  },
};

export const usePartials = () => {
  const { organization } = useFormTemplateContext();
  const { path, timezone_name } = organization;
  const contacts = useOrganizationContacts();

  // Memoize the support email to prevent unnecessary recalculations
  const supportEmail = useMemo(
    () =>
      contacts.find((contact) => contact.type === "email")?.value ??
      "support@avela.org",
    [contacts]
  );

  return useMemo(() => {
    const format = "MM-dd-yyyy HH:mm:ss zzz"; // From user-communication lambda

    return {
      ...PARTIALS,
      form: {
        name: PARTIALS.form.name,
        closeDate: formatInTimeZone(
          PARTIALS.form.closeDate,
          timezone_name,
          format
        ),
        offerDate: formatInTimeZone(
          PARTIALS.form.offerDate,
          timezone_name,
          format
        ),
      },
      organization: organization,
      applyUrl: `https://apply.avela.org/${path}`,
      supportEmail,
    };
  }, [timezone_name, organization, path, supportEmail]);
};
